// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/client/styles/default/waittingtask.less
// module id = 3231
// module chunks = 0